
export interface RoadmapUpdateRequest {
  /** 로드맵에 대한 상세 설명 (Markdown 가능) */
  content?: string;
  /**
   * 로드맵에 포함될 강의 ID 목록 (순서대로 정렬, 최소 2개 이상)
   * @minItems 2
   */
  courseIds: string[];
  /** 로드맵에 대한 간략한 설명 */
  description?: string;
  /** 로드맵 제목 */
  title: string;
}
